var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ac-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M23 18V3C23 1.9 22.1 1 21 1H12L10.4 4H3C1.9 4 1 4.9 1 6V21C1 22.1 1.9 23 3 23H10.4L12 20H21C22.1 20 23 19.1 23 18ZM21.5 18C21.5 18.3 21.3 18.5 21 18.5H13.5V2.5H21C21.3 2.5 21.5 2.7 21.5 3V18Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }